/**
 * Created by 212610877 on 5/19/2017.
 *
 *NEW
 * In template for image tag use
 * <img class="mmenu-select prefetch" src="/static/images/main-menu/blue-btn.png"/>
 *
 * In tempalte for div background use format
 * <div class="top-nav-sec prefetch-bg" style='background-image: url(./static/images/main-menu/header_bg.png)'></div>
 *
 * In css, use assets
 *  background-image: url('../assets/images/expansion-menu/arrow.png');
 *
 *   background-image: url('./static/images/expansion-menu/arrow.png');
 */
import { EventBus } from './event-bus';

(function (global) {
  require('es6-promise').polyfill();
  require('isomorphic-fetch');

  const debug = 0;
  const Preloader = {

    /**
     * Preload for current view.
     * @param name name of the route
     * @param next next function to unblock route, so it can proceed
     * @param preload is optional array list of assets
     */
    preloadForView(name, next, preload) {
      debugLog(`Preload for view ${name}`);
      /**
       * To combine the preload block and the videosource block as all assets in videoSource block
       * must be preloaded for the view.
       */
      const preloadList = combinePreloadResources(name, preload);
      load(preloadList, next, name); // current page assets (block entering route)
    },


    /**
     Load assets based on url
     */
    load(urls, next) {
      load(urls, next);
    },

    /**
     * Set the im
     * @param imgs img elements
     * @param cssBackgroundImgs div that has a style background-image
     */
    setImageSrc(imgs, cssBackgroundImgs) {
      imgs.forEach((img) => {
        debugLog(`check img src:${img.src}`);
        // debugger;
        img.src = getSourceURLfromCacheIfExists(img.src);
        debugLog(`new image src:${img.src}`);
      });
      // debugger;
      cssBackgroundImgs.forEach((backgroundDiv) => {
        let url = backgroundDiv.style.backgroundImage;
        url = url.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');   // remove url()
        // backgroundDiv.style.backgroundImage = 'url(' + getSourceURLfromCacheIfExists(url) + ')'; //add url()
        preloader.setBackGroundImage(backgroundDiv, url);
      });
    },

    getImageSrc(imgs) {
      // debugger;
      const allImgsSrc = [];
      imgs.forEach((img) => {
        allImgsSrc.push(img.src);
      });
      return allImgsSrc;
    },

    setImage(divElement, imageSrc) {
      divElement.src = getSourceURLfromCacheIfExists(imageSrc);
    },

    setBackGroundImage(divElement, imageSrc) {
      if (typeof imageSrc === 'string') {
        divElement.style.backgroundImage = `url(${getSourceURLfromCacheIfExists(imageSrc)})`; // add url()
      }
    },
  };

  /**
   * Traverse the object and flatten it so that all values in the object will be added to the array.
   * @param o  - json object
   * @param preloadArray  - an array
   * @returns {*}
   */
  function traverse(o, preloadArray) {
    for (const i in o) {
      if (o[i] !== null && typeof (o[i]) === 'object') {
        // going one step down in the object tree!!
        preloadArray.concat(traverse(o[i], preloadArray));
      } else {
        // console.log("value is " + o[i]);
        preloadArray.push(o[i]);
      }
    }
    return preloadArray;
  }

  /**
   * An array of nodes in config.json where we want to combine values.
   * @param nodes
   */
  function combinePreloadResources(name, dataPreload) {
    /**
     * Use traverse to flatten the video objects and put video, firstFrame, lastFrame in the the preload array.
     * @type {*}
     */
      // debugger;

      // combine preload and video in config.json
    const viewConfigJson = window.configMgr.views[name];
    if (typeof viewConfigJson === 'undefined') {
      throw new Error(`view ${name} is missing from config.json but it is defined in prefetch`);
    }

    let preloadArray = traverse(
      (typeof viewConfigJson.data === 'undefined' || typeof viewConfigJson.data.videoSource === 'undefined') ? [] : viewConfigJson.data.videoSource,
      typeof viewConfigJson.preload !== 'undefined' ? viewConfigJson.preload : []);

    // combine the above result with the preload in the Vue, data object.
    preloadArray = traverse(typeof dataPreload !== 'undefined' ? dataPreload : [], preloadArray);

    // use New Set() to remove duplicates
    const preload = Array.from(new Set(preloadArray));
    // console.log( preloadArray.length + " vs " +  preload.length);

    return preload;
  }


  function prefetchViewsFor(name) {
    debugLog('**************** PRE FETCH NEXT PAGES **************************');
    const prefetchViews = window.configMgr.views[name].prefetch; // next page assets (doesn't block entering route)
    if (prefetchViews) {
      prefetchViews.forEach((view) => {
        debugLog(`Prefetch for view ${view}`);
        // debugger;
        const preload = combinePreloadResources(view);
        preloader.load(preload);
      });
    }
  }

  function load(urls, next, name) {
    let counter = 0;
    debugLog(`Counter is reset to ${counter}`);
    const numberOfItems = urls.length;
    debugLog(`Number of Items to load is ${numberOfItems}`);

    function areAllItemsLoaded() {
      // debugger;
      if (counter === numberOfItems && typeof next === 'function') {
        debugLog('****************All items are loaded; call Next()*******************');
        next((vm) => {
          // Assets loading for current route is done
          EventBus.$emit('router-view-loaded', name);

          // Prefetch for other view from this ${name}
          prefetchViewsFor(name);
        }); // call this function to callback when everything is done.
      }
    }

    if (urls.length > 0) {
      urls.forEach((url) => {
        if (url in window.dataStore) {
          debugLog(`Found resource in cache already: ${url}`);
          counter += 1;  // already in cache
          areAllItemsLoaded();
        } else {
          // Only prefetch what's in the static folder
          if (typeof url === 'string' && url.indexOf('./static') === 0) {
            prefetch(url, next)
              .then((blobUrl) => {
                  // debugger;
                  // Using a simple object, dataStore, as application cache
                window.dataStore[url] = blobUrl;
                debugLog(`Storing data for url :${url}`);
                counter += 1;
                debugLog(`Number of items loaded :${counter}`);
                areAllItemsLoaded();
              },
              );
          } else {
            counter += 1; // increment the counter because it is in the array but we skip preloading
            debugLog(`Number of items skipped :${counter}`);
            areAllItemsLoaded();
          }
        }
      });
    } else {
      areAllItemsLoaded();
    }
  }


  /**
   * Prefetch video based on url.
   * @param url
   * @returns {Promise.<TResult>}
   */
  function prefetch(url) {
    // debugger;
    // IE will fail this block
    return new Promise((resolve, reject) => { // here we download it entirely
      const request = new XMLHttpRequest();
      request.responseType = 'blob';
      request.onload = evt => resolve(request.response);
      request.onerror = reject;
      request.open('GET', url);
      request.send();
    }).then(blob =>
      new Promise((resolve, reject) => {
        // debugger;
        resolve(URL.createObjectURL(blob)); // return the blobURL directly
      }),
    ).catch((err) => {
      // debugger;
      debugLog(`${err} - IE fail XHR request and use fetch`);
      return fetch(url, { mode: 'no-cors' })
        .then(resp => resp.blob())
        .then(blob => URL.createObjectURL(blob));
    });
  }

  function debugLog(msg) {
    if (debug === 1) {
      console.log(msg);
    }
  }

  function getSourceURLfromCacheIfExists(src) {
    debugLog(`Is resource in cache? ${src}`);
    // debugger;
    // src is in format
    // http://localhost:8080/static/images/main-menu/optimizing-fleets.png
    // when put in cache; the key was
    // ./static/images/main-menu/optimizing-fleets.png
    // thus need to replace the location.origin (http://localhost:8080) with "."
    // var key = src.replace(location.origin, '.');
    // debugger;
    const key = `.${src.substring(src.indexOf('/static/'))}`;
    if (key in window.dataStore) {
      debugLog('Resource is in cache');
      return window.dataStore[key];
    }
    return src;
  }

  /**
   * Expose Preloader depending on the module system used across the
   * application. (Node / CommonJS, AMD, global)
   */

  if (typeof exports === 'object') {
    module.exports = Preloader;
  } else if (typeof define === 'function' && define.amd) {
    define(() => Preloader);
  } else {
    global.Preloader = Preloader;
  }
}(this));



// WEBPACK FOOTER //
// ./src/assets/js/preloader.js